<template>
  <div class="index-container">
    <!-- header -->
    <com-header
      ref="comHeader"
      :refresh="false"
      @setUserInfo="setUserInfo"
    ></com-header>
    <!-- banner -->
    <div class="banner-wrap">
      <div class="banner-left">
        <banner :banners="banners"></banner>
      </div>
      <div class="login-right">
        <login-card v-if="!isLogin"></login-card>
        <user-card v-else :user-name="userInfo.customerName"></user-card>
        <div class="side-menu">
          <img-text-card
            text="发布需求"
            :img="releaseIcon"
            @handleClick="releaseDemand"
          ></img-text-card>
          <img-text-card
            text="我要开店"
            :img="kaidian"
            @handleClick="toRegisterShop"
          ></img-text-card>
        </div>
        <div class="new-enterprise">
          <div class="left-headline">
            <img src="./imgs/renzheng.png" alt="" />
            新认证企业
          </div>
          <el-carousel
            height="78px"
            direction="vertical"
            :interval="5000"
            indicator-position="none"
            arrow="never"
          >
            <el-carousel-item
              v-for="(keyword, index) in Math.round(
                newAuthEnterprise.length / 3
              )"
              :key="index"
              class="new-enterprise"
            >
              <ul>
                <li v-for="(item, n) in 3" :key="n + '-' + index">
                  ·&nbsp;&nbsp;{{ newAuthEnterprise[index * 3 + n] }}
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 需求大厅 -->
    <demand></demand>
    <!-- 广告图 -->
    <div class="adv-banner-floor conduct-banner" style="1px solid red">
      <img src="./imgs/adv-img.png" alt="" />
    </div>

    <!-- 企业 -->
    <enterprise></enterprise>

    <!-- 生态圈 -->
    <div class="ecosystem floor-item">
      <div class="headline">打造装配式建筑产业生态圈</div>
      <ul class="ecosp-list">
        <li class="ecosp-item">
          <img src="./imgs/search-bg.png" class="ecosp-bg" alt />
          <div class="ecosp-content">
            <img src="./imgs/en-search.png" />
            <p class="title">企业查询</p>
            <p class="content">
              行业名录，信息咨询
              <br />
              促进产业互联
            </p>
          </div>
        </li>
        <li class="ecosp-item">
          <img src="./imgs/xin-bg.png" class="ecosp-bg" alt />
          <div class="ecosp-content">
            <img src="./imgs/xin.png" />
            <p class="title">行业信用</p>
            <p class="content">
              用户评价，企业信用
              <br />
              客观且真实
            </p>
          </div>
        </li>
        <li class="ecosp-item">
          <img src="./imgs/map-bg.png" class="ecosp-bg" alt />
          <div class="ecosp-content">
            <img src="./imgs/map-icon.png" />
            <p class="title">产业地图</p>
            <p class="content">
              地图信息，地理匹配
              <br />
              让需求变的更简单
            </p>
          </div>
        </li>
        <li class="ecosp-item">
          <img src="./imgs/tp-bg.png" class="ecosp-bg" alt />
          <div class="ecosp-content">
            <img src="./imgs/tianping.png" />
            <p class="title">供需撮合</p>
            <p class="content">
              精准工程，采购信息
              <br />
              为行业提供数字服务
            </p>
          </div>
        </li>
        <li class="ecosp-item">
          <img src="./imgs/group-bg.png" class="ecosp-bg" alt />
          <div class="ecosp-content">
            <img src="./imgs/group.png" />
            <p class="title">社区人脉</p>
            <p class="content">
              行业名录，信息咨询
              <br />
              促进产业互联
            </p>
          </div>
        </li>
      </ul>
    </div>

    <!-- 合作伙伴 -->
    <div class="partner floor-item">
      <div class="partner-img"></div>
    </div>

    <home-service></home-service>
    <!-- footer -->
    <com-footer></com-footer>

    <!-- 侧边导航 start -->
    <div class="side-nav-box">
      <side-nav></side-nav>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import banner from './components/banner'
import loginCard from './components/loginCard'
import userCard from './components/userCard'
import imgTextCard from './components/imgTextCard'
import demand from './components/demand'
import enterprise from './components/enterprise'
import homeService from '../../components/HomeService.vue'
import sideNav from './components/sideNav'
import { _debounce } from '../../util/public'

const bannerList = [
  {
    id: 'banner1',
    img: require('../../assets/images/banner/banner-1.png'),
    href: '',
  },
  {
    id: 'banner2',
    img: require('../../assets/images/banner/banner-2.png'),
    href: '',
  },
  {
    id: 'banner3',
    img: require('../../assets/images/banner/banner-3.png'),
    href: '',
  },
]
const newEnterprise = [
  '杭萧钢构股份有限公司',
  '阳地钢(上海)装配式建筑股份有限公司',
  '安徽科汇钢结构工程有限公司',
  '山东贝加尔新型建材有限公司',
  '昆山巨丰泽钢结构有限公司',
  '大禾众邦（厦门）智能科技股份有限公司',
  '上海建材（集团）有限公司',
  '潍坊市路通机械电子有限公司',
  '广东高翰金属制品有限公司',
  '上海柜众货柜有限公司',
  '上海链佳宜建筑科技有限公司',
  '南通华恒智能科技有限公司',
  '惠州市丰源钢结构有限公司',
  '河北兆建金属制品有限公司',
  '枣庄钢锢诚焊材有限公司',
  '荆州市楚天钢构有限公司',
  '浙江铭凯集成房屋有限公司',
  '合肥市集何模块化建筑有限公司',
  '上海钢之杰钢结构建筑系统有限公司',
  '上海宏郯建筑装饰工程有限公司',
  '安徽中亚钢结构工程有限公司',
  '北京金兆博高强度紧固件有限公司',
  '山东上冶钢构股份有限公司',
  '江苏七子建设科技有限公司',
]
export default {
  name: 'Index',
  components: {
    banner,
    loginCard,
    userCard,
    imgTextCard,
    demand,
    enterprise,
    homeService,
    sideNav,
  },
  data() {
    return {
      shopWebsite: process.env.VUE_APP_SHOP_WEBSITE,
      banners: bannerList,
      releaseIcon: require('./imgs/release.png'),
      kaidian: require('./imgs/kaidian.png'),
      newAuthEnterprise: newEnterprise,
      // 搜索关键词
      searchTxt: '',
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
    }
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.login.isLogin,
      userInfo: (state) => state.login.userInfo,
    }),
  },
  methods: {
    // 获取用户信息
    setUserInfo(userInfo, isLogin) {
      this.userInfo = userInfo
      this.isLogin = isLogin
    },

    // 需求更多
    toDemandHall() {
      this.$router.push('/demandHall')
    },

    // 去开店
    toRegisterShop() {
      let href = `${process.env.VUE_APP_SHOP_BASEURL}/company-register`
      window.open(href)
    },

    // 发布需求
    releaseDemand() {
      const routerData = this.$router.resolve({
        path: '/release',
      })
      window.open(routerData.href)
    },
  },
}
</script>

<style lang="scss" scoped>
.index-container {
  width: 100%;
  background: #f8f8f8;
  .t-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .fontw {
    font-weight: bold;
  }
  // banner
  .banner-wrap {
    width: 1200px;
    height: 300px;
    margin: 6px auto 0;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .banner-left {
      width: 932px;
    }
    .login-right {
      width: 258px;
      background: #ffffff;
      .side-menu {
        height: 94px;
        padding: 0 10px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: 2px;
      }
      .new-enterprise {
        height: 105px;

        .left-headline {
          border-top: 1px solid #eeeeee;
          padding: 10px 20px;
          font-size: 12px;
          font-weight: bold;
          color: #333333;
          line-height: 17px;
          display: flex;
          align-items: center;
          margin-bottom: 2px;
          img {
            width: 12px;
            height: 12px;
            margin-right: 3px;
          }
        }
        .new-enterprise ul {
          li {
            color: #333333;
            width: 100%;
            font-size: 11px;
            line-height: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 8px;
            padding: 0 10px 0 24px;
          }
          li:hover {
            color: #ce2939;
          }
        }
      }
    }
    a.img-wrap {
      height: 100%;
      display: flex;
      justify-content: center;
    }
    img {
      height: 100%;
      object-fit: cover;
    }
  }

  // 广告图
  .conduct-banner {
    width: 1200px;
    height: 100px;
    margin: 40px auto 0;
    img {
      width: 100%;
      height: auto;
    }
  }

  // 生态圈
  .ecosystem {
    width: 1200px;
    margin: 0 auto;
    padding-top: 53px;
    .headline {
      font-size: 25px;
      font-weight: 600;
      color: #333333;
      line-height: 36px;
      text-align: center;
      margin: 0 0 30px;
    }
    // ul.ecology-list {
    //   display: flex;
    //   li {
    //     width: 240px;
    //     height: 380px;
    //     flex: 1;
    //     text-align: center;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     flex-direction: column;
    //     color: #ffffff;
    //     background-repeat: no-repeat;
    //     background-size: contain;
    //     background-position: center;
    //     .ecology-img {
    //       width: 50px;
    //       height: 50px;
    //       img {
    //         width: 100%;
    //         height: auto;
    //       }
    //     }
    //     .ecosystem-bg {
    //       transition: all 0.5s linear;
    //       overflow: hidden;
    //     }
    //     &:hover {
    //       .ecosystem-bg img {
    //         transform: scale(1.15);
    //       }
    //     }
    //     .title {
    //       margin-top: 10px;
    //       font-size: 22px;
    //       font-weight: bold;
    //       line-height: 30px;
    //     }
    //     .content {
    //       font-size: 14px;
    //       line-height: 20px;
    //       margin-top: 24px;
    //     }
    //   }
    //   li:nth-child(2n) {
    //     color: #333333;
    //   }
    //   .bg-search {
    //     background-image: url('./imgs/search-bg.png');
    //   }
    //   .bg-xin {
    //     background-image: url('./imgs/xin-bg.png');
    //   }
    //   .bg-map {
    //     background-image: url('./imgs/map-bg.png');
    //   }
    //   .bg-tp {
    //     background-image: url('./imgs/tp-bg.png');
    //   }
    //   .bg-group {
    //     background-image: url('./imgs/group-bg.png');
    //   }
    // }
    ul.ecosp-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      li.ecosp-item {
        width: 240px;
        height: 380px;
        position: relative;
        overflow: hidden;
        .ecosp-bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          transition: all 0.5s linear;
        }
        .ecosp-content {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          color: #000000;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          letter-spacing: 1px;
          overflow: hidden;
          img {
            width: 50px;
            height: 50px;
          }
          .title {
            margin: 20px 0 36px;
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            line-height: 30px;
          }
          .content {
            height: 64px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 20px;
            text-align: center;
          }
        }
      }
      .ecosp-item:nth-child(odd) {
        .ecosp-content {
          color: #ffffff;
        }
      }
      .ecosp-item:hover {
        img.ecosp-bg {
          transform: scale(1.15);
        }
      }
    }
  }

  // 合作伙伴
  .partner {
    width: 1200px;
    margin: 0 auto 118px;
    padding-top: 80px;
    .partner-img {
      width: 100%;
      height: 336px;
      background-image: url('./imgs/partner.png');
      background-position: center;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .side-nav-box {
    width: 58px;
    position: fixed;
    top: 50%;
    right: 80px;
    transform: translateY(-50%);
    z-index: 99;
  }

  .black-tip {
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    color: #999999;
    text-align: center;
    .no-data {
      width: 70px;
      height: 80px;
      margin: 0 auto 30px;
      overflow: hidden;
      img {
        // margin-top: 120px;
        width: 100%;
      }
    }
    p {
      font-size: 16px;
      color: #666666;
    }
  }
  .pagenation {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
@media screen and (max-width: 1300px) {
  .index-container .side-nav-box {
    width: 58px;
    position: fixed;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    z-index: 99;
  }
}
</style>

<style lang="scss">
.banner-wrap {
  .el-carousel__arrow {
    display: none;
  }
  .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 12px 4px;
    // display: none;
  }
}
.screen-conditions {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fe444d;
    border-color: #fe444d;
  }
  .el-checkbox {
    color: #000000;
  }
  .el-checkbox__inner {
    border: 1px solid #d9d9d9;
  }
}
</style>
